/* eslint-disable import/prefer-default-export */
import { UseQueryOptions } from "@tanstack/react-query";
import { getProviderOptions } from "api/services/quoteRequest";
import { useCustomQuery } from "hooks/useCustomQuery";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

type GetProviderOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetProviderOptions = (data: GetProviderOptions) =>
  useCustomQuery<any>({
    queryKey: quoteRequestQueryKeys.quoteProviderOptionsListing(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getProviderOptions(data.shipmentId).then((res) => res.data),
    ...data.options,
  });
